import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import {
  BaseButton,
  BaseTextField,
  BaseTypography,
} from '../../../../../components/common';
import { makeStyles } from '@material-ui/core/styles';
import { validationErrors } from '../../../../../utils/validation/validationErrors';

const useStyles = makeStyles(() => ({
  submitBtn: {
    marginTop: '20px',
  },
  content: {
    display: 'grid',
    gridGap: '15px',
  },
}));

type PMsCodeForm = {
  onUseCode?: any;
  onSubmit: any;
  loading?: boolean;
};

export const MsRecoveryCodeForm: React.FC<PMsCodeForm> = (props) => {
  const { onSubmit, onUseCode, loading } = props;
  const classes = useStyles();
  const formik = useFormik({
    validationSchema: yup.object().shape({
      recovery_code: yup.string().required(validationErrors.REQUIRED_FIELD),
    }),
    initialValues: {
      recovery_code: '',
    },
    onSubmit: (values) => {
      onSubmit(values);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className={classes.content}>
        <BaseTypography variant="caption">
          Enter one of your Microsoft Authenticator App recovery codes. Note
          each code can be used once. app <br />
          Or{' '}
          <span className="primary pointer" onClick={onUseCode}>
            Enter Microsoft Authenticator code
          </span>
        </BaseTypography>
        <BaseTextField
          label="Recovery code"
          value={formik.values.recovery_code}
          onChange={formik.handleChange}
          errorText={formik.errors.recovery_code}
          name="recovery_code"
        />
        <BaseButton
          type="submit"
          className={classes.submitBtn}
          loading={loading}
        >
          Send
        </BaseButton>
      </div>
    </form>
  );
};
